module.exports = {
    DESKTOP: 'desktop',
    TABLET: 'tablet',
    PHONE: 'phone',
};
